import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { TimeEntryTypeConst, TimeEntryTypeLabel } from "@/types/timeEntry";

// Entrada = verde, saída = vermelho, início/fim de intervalo = azul.
const TYPE_STYLES: Record<number, string> = {
  [TimeEntryTypeConst.ENTRADA]:
    "bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-500/15 dark:text-emerald-400 dark:border-emerald-500/30",
  [TimeEntryTypeConst.SAIDA]:
    "bg-red-100 text-red-700 border-red-200 dark:bg-red-500/15 dark:text-red-400 dark:border-red-500/30",
  [TimeEntryTypeConst.INICIO_INTERVALO]:
    "bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-500/15 dark:text-blue-400 dark:border-blue-500/30",
  [TimeEntryTypeConst.FIM_INTERVALO]:
    "bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-500/15 dark:text-blue-400 dark:border-blue-500/30",
};

export const TimeEntryTypeBadge = ({ type }: { type?: number | null }) => {
  if (!type || !TimeEntryTypeLabel[type]) return <>-</>;

  return (
    <Badge variant="outline" className={cn("whitespace-nowrap", TYPE_STYLES[type])}>
      {TimeEntryTypeLabel[type]}
    </Badge>
  );
};
